import { render, staticRenderFns } from "./GridMenu.vue?vue&type=template&id=4a0d2fb6"
import script from "./GridMenu.vue?vue&type=script&lang=js"
export * from "./GridMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports